// Asansör Mock Data
// Asansör siparişleri, montaj ilerlemesi ve bakım sözleşmesi takibi

export const asansorSiparisler = [
    {
        id: 'as-001',
        siparisTarihi: '2026-01-05',
        teslimTarihi: '2026-02-15',
        tedarikci: 'Otis Asansör',
        tedarikciFirmaId: 'f-030',
        marka: 'Otis',
        model: 'Gen2 Comfort',
        kapasite: '630 kg / 8 kişi',
        kat: 6,
        durakSayisi: 7,
        birimFiyat: 450000,
        toplamFiyat: 450000,
        miktar: 1,
        birim: 'adet',
        durum: 'montaj',
        montajIlerleme: 65,
        insaatId: 'c1',
        blokAdi: 'A Blok',
        garanti: '24 ay',
        bakimSozlesmesi: true,
        not: 'Montaj devam ediyor, kabin takıldı, ray montajı tamamlandı',
        createdAt: '2026-01-05T10:00:00Z',
        updatedAt: '2026-02-10T14:00:00Z',
    },
    {
        id: 'as-002',
        siparisTarihi: '2026-01-05',
        teslimTarihi: '2026-02-20',
        tedarikci: 'Otis Asansör',
        tedarikciFirmaId: 'f-030',
        marka: 'Otis',
        model: 'Gen2 Comfort',
        kapasite: '630 kg / 8 kişi',
        kat: 6,
        durakSayisi: 7,
        birimFiyat: 450000,
        toplamFiyat: 450000,
        miktar: 1,
        birim: 'adet',
        durum: 'bekliyor',
        montajIlerleme: 0,
        insaatId: 'c1',
        blokAdi: 'B Blok',
        garanti: '24 ay',
        bakimSozlesmesi: true,
        not: 'Kuyuluk hazır, montaj bekliyor',
        createdAt: '2026-01-05T10:00:00Z',
        updatedAt: '2026-01-20T09:00:00Z',
    },
    {
        id: 'as-003',
        siparisTarihi: '2026-01-10',
        teslimTarihi: '2026-03-01',
        tedarikci: 'Kone Asansör',
        tedarikciFirmaId: 'f-031',
        marka: 'Kone',
        model: 'MonoSpace 500',
        kapasite: '1000 kg / 13 kişi',
        kat: 8,
        durakSayisi: 9,
        birimFiyat: 620000,
        toplamFiyat: 620000,
        miktar: 1,
        birim: 'adet',
        durum: 'uretim',
        montajIlerleme: 0,
        insaatId: 'c2',
        blokAdi: 'A Blok',
        garanti: '36 ay',
        bakimSozlesmesi: true,
        not: 'Fabrikada üretim aşamasında',
        createdAt: '2026-01-10T11:00:00Z',
        updatedAt: '2026-01-25T16:00:00Z',
    },
    {
        id: 'as-004',
        siparisTarihi: '2026-01-10',
        teslimTarihi: '2026-03-15',
        tedarikci: 'Kone Asansör',
        tedarikciFirmaId: 'f-031',
        marka: 'Kone',
        model: 'MonoSpace 500',
        kapasite: '1000 kg / 13 kişi',
        kat: 8,
        durakSayisi: 9,
        birimFiyat: 620000,
        toplamFiyat: 620000,
        miktar: 1,
        birim: 'adet',
        durum: 'bekliyor',
        montajIlerleme: 0,
        insaatId: 'c2',
        blokAdi: 'B Blok',
        garanti: '36 ay',
        bakimSozlesmesi: true,
        not: 'Sipariş onaylandı, üretim sırasında',
        createdAt: '2026-01-10T11:00:00Z',
        updatedAt: '2026-01-15T10:00:00Z',
    },
    {
        id: 'as-005',
        siparisTarihi: '2026-01-15',
        teslimTarihi: '2026-03-20',
        tedarikci: 'Kone Asansör',
        tedarikciFirmaId: 'f-031',
        marka: 'Kone',
        model: 'MonoSpace 300',
        kapasite: '630 kg / 8 kişi',
        kat: 6,
        durakSayisi: 7,
        birimFiyat: 520000,
        toplamFiyat: 520000,
        miktar: 1,
        birim: 'adet',
        durum: 'bekliyor',
        montajIlerleme: 0,
        insaatId: 'c2',
        blokAdi: 'C Blok',
        garanti: '36 ay',
        bakimSozlesmesi: false,
        not: 'Henüz bakım sözleşmesi yapılmadı',
        createdAt: '2026-01-15T14:00:00Z',
        updatedAt: '2026-01-15T14:00:00Z',
    },
];

// Asansör durumları
export const asansorDurumlari = [
    { key: 'bekliyor', label: 'Bekliyor', color: 'bg-bg-tertiary text-text-muted' },
    { key: 'uretim', label: 'Üretimde', color: 'bg-info/10 text-info' },
    { key: 'montaj', label: 'Montajda', color: 'bg-warning/10 text-warning' },
    { key: 'teslim', label: 'Teslim / Aktif', color: 'bg-success/10 text-success' },
];

// İstatistikler
export const getAsansorStats = (insaatId) => {
    const filtered = insaatId
        ? asansorSiparisler.filter(s => s.insaatId === insaatId)
        : asansorSiparisler;

    const toplamAdet = filtered.length;
    const montajda = filtered.filter(s => s.durum === 'montaj').length;
    const bekleyen = filtered.filter(s => s.durum === 'bekliyor' || s.durum === 'uretim').length;
    const toplamMaliyet = filtered.reduce((acc, s) => acc + s.toplamFiyat, 0);

    return { toplamAdet, montajda, bekleyen, toplamMaliyet, toplamKalem: toplamAdet };
};

// Helper
export const getAsansorByInsaat = (insaatId) => {
    if (!insaatId) return asansorSiparisler;
    return asansorSiparisler.filter(s => s.insaatId === insaatId);
};
